import {createVuetify} from 'vuetify';
import 'vuetify/styles';
import {de} from 'vuetify/locale';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

const nonce = window.__cspNonce;
const vuetify = createVuetify({
    locale: {
        locale: 'de',
        defaultLocale: 'de',
        messages: {de},
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    background: '#FFFFFF',
                    surface: '#FFFFFF',
                    'surface-bright': '#FFFFFF',
                    'surface-light': '#ededed',
                    'surface-variant': '#575757',
                    'on-surface-variant': '#ededed',
                    primary: '#071727',
                    'primary-light': '#071727',
                    'primary-darken-1': '#000',
                    secondary: '#DD0935',
                    'secondary-darken-1': '#8F222E',
                    accent: '#BED2D7',
                    error: '#EB505F',
                    info: '#BED2D7',
                    success: '#37A087',
                    warning: '#FFC31E',
                },
                variables: {
                    'border-opacity': 0.8,
                },
            },
        },
        cspNonce: nonce,
    },
    components,
    directives
});

export default vuetify;
